import Vue from 'vue'
import Router from 'vue-router'
import Payment from './views/Payment.vue'
import PaymentSuccess from "./components/PaymentSuccess";
import TimedOut from "./components/TimedOut";
import PaymentFailed from './components/PaymentFailed';
import PaymentPending from './components/PaymentPending';
import Signature from './components/PaymentSignature';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Payment
    },
    {
      path: '/success',
      name: 'success',
      component: PaymentSuccess
    },
    {
      path: '/timed-out',
      name: 'timedOut',
      component: TimedOut
    },
    {
      path: '/signature',
      name: 'signature',
      component: Signature
    },
    {
      path: '/failed',
      name: 'failed',
      component: PaymentFailed
    },
    {
      path: '/pending',
      name: 'pending',
      component: PaymentPending
    }
  ]
})
